import CareLevelAnalysisModal from './CareLevelAnalysisModal';

export default CareLevelAnalysisModal;
